/**
 * @file Boucle a pas FIXE (accumulateur) : tics de simulation a 20 Hz decouples de l'affichage (requestAnimationFrame), alpha d'interpolation, rattrapage borne.
 */

export interface GameLoopHandlers {
  /** Un tic de simulation (dt fixe). */
  tick(): void;
  /** Une frame d'affichage : alpha = fraction du tic suivant deja ecoulee (0..1), frameDt = temps reel (s, borne a 0.1). */
  frame(alpha: number, frameDt: number, timeSeconds: number): void;
}

export class GameLoop {
  private acc = 0;
  private last = 0;
  private raf = 0;
  private running = false;
  private time = 0;
  /** Nombre de tics abandonnes (onglet gele) : le hors-ligne prend le relais au retour. */
  droppedTicks = 0;

  constructor(
    private readonly dt: number,
    private readonly maxCatchUpTicks: number,
    private readonly h: GameLoopHandlers,
  ) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    this.acc = 0;
    const loop = (now: number): void => {
      if (!this.running) return;
      const frameDt = Math.min(0.1, Math.max(0, (now - this.last) / 1000));
      this.acc += (now - this.last) / 1000;
      this.last = now;
      let n = 0;
      while (this.acc >= this.dt && n < this.maxCatchUpTicks) {
        this.h.tick();
        this.acc -= this.dt;
        n++;
      }
      if (this.acc >= this.dt) {
        this.droppedTicks += Math.floor(this.acc / this.dt);
        this.acc %= this.dt;
      }
      this.time += frameDt;
      this.h.frame(this.acc / this.dt, frameDt, this.time);
      this.raf = requestAnimationFrame(loop);
    };
    this.raf = requestAnimationFrame(loop);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.raf);
  }

  get isRunning(): boolean {
    return this.running;
  }
}
